import { CSSProp, css } from 'styled-components';

type MediaQueryProps = {
  fold: number;
  mobile: number;
  tablet: number;
};

const sizes: MediaQueryProps = {
  fold: 320,
  mobile: 768,
  tablet: 1024,
};

type BackQuoteArgs = string[];

const media = {
  fold: (literals: TemplateStringsArray, ...args: BackQuoteArgs): CSSProp => css`
    @media screen and (max-width: ${sizes.fold}px) {
      ${css(literals, ...args)}
    }
  `,
  mobile: (literals: TemplateStringsArray, ...args: BackQuoteArgs): CSSProp => css`
    @media screen and (min-width: 321px) and (max-width: ${sizes.mobile}px) {
      ${css(literals, ...args)}
    }
  `,
  tablet: (literals: TemplateStringsArray, ...args: BackQuoteArgs): CSSProp => css`
    @media screen and (min-width: 767px) and (max-width: ${sizes.tablet}px) {
      ${css(literals, ...args)}
    }
  `,
} as Record<keyof typeof sizes, (l: TemplateStringsArray, ...p: BackQuoteArgs) => CSSProp>;

export default media;
